<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :label="$t('CargoMsg.Cargo_AutomationConfig')" name="automationConfig">
              <automation-task />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_TaskScenario')" name="taskScenario">
              <task-scenario />
            </el-tab-pane>
            <!-- <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_ExecuteCommand')" name="executeCommand"></el-tab-pane>-->
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TaskScenario from '@/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/taskScenario'
import AutomationTask from '@/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/automationTask.vue'

export default {
  name: 'SystemAutomationConfig',
  components: { AutomationTask, TaskScenario },
  data() {
    return {
      activeTabName: 'automationConfig'
    }
  },
  methods: {
    handleClick() {

    }
  }
}
</script>
